<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body>
      <div class="edit-profile-basic-details container col-lg-8 col-sm-12">
        <ValidationObserver ref="basicDetails">
          <Permissioned section="workers.edit" vertical>
            <ValidationProvider
              :permission="permissions.name"
              v-slot="{ errors }"
              name="firstName"
              rules="required"
            >
              <v-text-field
                class="pb-5"
                hide-details
                height="50"
                @input="value => handleChange('firstName', value)"
                v-model="user.firstName"
                :error-messages="getErrorMessages(errors)"
                label="First Name"
                placeholder="First Name"
              />
            </ValidationProvider>
            <ValidationProvider
              :permission="permissions.name"
              v-slot="{ errors }"
              name="lastName"
              rules="required"
            >
              <v-text-field
                class="pb-5"
                hide-details
                height="50"
                @input="value => handleChange('lastName', value)"
                v-model="user.lastName"
                :error-messages="getErrorMessages(errors)"
                label="Last Name"
                placeholder="Last Name"
              />
            </ValidationProvider>
            <div class="action-item" :permission="permissions.email">
              <v-text-field label="Email Address" :value="user.email" readonly>
                <template v-slot:append>
                  <ChangeEmailAction />
                </template>
              </v-text-field>
            </div>
            <div class="action-item" :permission="permissions.password">
              <v-text-field type="password" label="Password" value="password">
                <template v-slot:append>
                  <ChangePasswordAction />
                </template>
              </v-text-field>
            </div>
          </Permissioned>
        </ValidationObserver>
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        @click.native="handleSave"
        :loading="isEditingDetails"
        :fullWidth="isMobile"
      >
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { isEmpty, pick } from "lodash";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import ChangePasswordAction from "@/views/settings/components/actions/ChangePasswordAction";
import ChangeEmailAction from "@/views/settings/components/actions/ChangeEmailAction";
import DialogFull from "@/components/common/DialogFull";
import { EDIT_USER } from "@/store/modules/users/actions";
import { USERS_NAMESPACE } from "@/store/modules/users";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import Permissioned from "@/components/common/Permissioned";
import { PERMISSIONS } from "@/constants/workers";

const { mapState } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapActions } = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ChangePasswordAction,
    DialogFull,
    PrimaryButton,
    Permissioned,
    ChangeEmailAction
  },
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      showValidationErrors: false,
      isEditingDetails: false,
      editableData: {},
      permissions: PERMISSIONS.BASIC_DETAILS
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Basic Details"
      };
    },
    ...mapState({
      userData: state => state.userData
    }),
    user() {
      return pick(this.userData, ["firstName", "lastName", "email", "id"]);
    }
  },
  methods: {
    ...mapActions({
      editUser: EDIT_USER
    }),
    async handleSave() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.basicDetails.validate();
      if (isValid) {
        this.showValidationErrors = false;
        this.isEditingDetails = true;
        if (!isEmpty(this.editableData)) {
          await this.editUser({
            id: this.user.id,
            data: this.editableData
          });
        }
        this.editableData = {};
        this.isEditingDetails = false;
        this.close();
      }
    },
    handleChange(property, value) {
      this.editableData[property] = value;
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.edit-profile-basic-details {
  padding: 20px;

  .action-item {
    width: 100%;
    margin: 0;
    padding: 0px;

    .base-button.shrink.v-btn:not(.v-btn--round).v-size--default {
      position: absolute;
      right: -2px;
      top: -1px;
    }
  }
}
</style>
